<template>
  <div class="rechargeOrder" :style="rechargeOrderStyle" :class="{'isiOSX':isiOSX}">
    <div class="wrapper">
      <div class="top">
        <nav-bar titleText="充值中心" rightText="充值订单" bg="linear-gradient(270deg,rgba(244, 26, 60, 1) 0%,rgba(252, 116, 12, 1) 100%)" isFixed="" @goBack="goBack" @rightTextEvent="goOrderList"></nav-bar>
        <p class="phone">{{ phone | phoneFormat}}</p>
        <!-- <input class="phone" type="taxt" :value="this.phone | this.phoneFormat" placeholder=""/> -->
        <p class="desc">话费充值仅限默认号码({{ yunyingshang }})</p>
      </div>
      <div class="phone-recharge" v-if="phoneDenominationList.length">
        <div class="phone-top">
          <div class="title">话费充值</div>
          <div class="tips" @click="showDialog2=true">
            <img src="../../assets/recharge/alert@2x.png" alt />
            <span>充值说明</span>
          </div>
        </div>
        <div class="phone-btn-box">
          <div class="phone-btn" v-for="(list, i) in phoneDenominationList" :key="i">
            <div class="btn" :class="{'phone-active': i===phoneActive.i && j===phoneActive.j}" v-for="(item, j) in list" :key="j" @click="toPay(item, i, j)">
              <p class="price">{{item.price}}元</p>
              <p class="credit">
                赠<span>{{(item.credits).toFixed(2)}}</span>积分
              </p>
            </div>
          </div>
        </div>
      </div>
      <div class="new-oli-enter-div" v-if="new_oil_display==1 && (phone != 13733333333 && phone != 19800000000) && package_name != 'vivo'">
        <div class="new-oli-title">新版油卡充值</div>
        <div class="new-oli-second-div">
          <div class="oli-second-left">
            <img v-if="oil_logo" :src="oil_logo" alt="">
          </div>
          <div class="oli-second-center">
            <div>新版<span>油卡充值</span>上线啦！</div>
            <div>油卡直充，充值更便捷</div>
          </div>
          <div class="oli-second-right" @click="goPage('/new-oli/recharge')"><span>去充值</span></div>
        </div>
      </div>
      <div class="buttom-wrapper">
        <div class="oil-card" v-if="phone != 13733333333 && phone != 19800000000 && package_name != 'vivo'">
          <div class="title">油卡充值</div>
          <div class="isCard">
            <div class="left" @click="oilCardAdd">
              <span>有卡</span>
              <a href="#">去添加</a>
            </div>
            <div class="right" @click="oilCardPay">
              <span>无卡</span>
              <a href="#">去购买</a>
            </div>
          </div>
        </div>
        <div class="movies-musics" v-if="moviesList.length && moviesModuleEnable === true">
          <div class="title">影视会员</div>
          <div class="moviesList">
            <ul v-for="(list,i) in moviesList" :key="i" class="van-clearfix">
              <li v-for="(item,j) in list" :key="j" @click="toPlatformRechage(item)">
                <img :src="item.charge_logo" alt />
                <div>{{item.charge_name}}</div>
              </li>
            </ul>
          </div>
        </div>
        <div class="movies-musics" v-if="musicList.length && musicModuleEnable === true">
          <div class="title">音乐娱乐</div>
          <div class="moviesList">
            <ul v-for="(list,i) in musicList" :key="i" class="van-clearfix">
              <li v-for="(item,j) in list" :key="j" @click="toPlatformRechage(item)">
                <img :src="item.charge_logo" />
                <div>{{item.charge_name}}</div>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>

    <div class="bottom-bar" v-if="isiOSX"></div>

    <van-dialog v-model="showDialog" :message="dialogMessage" confirm-button-text="去处理" confirm-button-color="#F9591B" cancel-button-text="取消" cancel-button-color="#999999" @confirm="goOrderList" @cancel="cancelEvent" show-cancel-button></van-dialog>
    <van-dialog v-model="showDialog2" :title="tipsTitle" confirm-button-text="我知道了" confirm-button-color="#F9591B" @confirm="showDialog2=false" class="last_dialog">
      <template v-slot:default>
        <div v-for="(item,i) in tipsMessages" :key="i">{{item}}</div>
      </template>
    </van-dialog>

    <van-dialog v-model="showDialog3" :title="tipsTitle2" confirm-button-text="返回" confirm-button-color="#F9591B" @confirm="goBack3" class="llast_dialog">
    </van-dialog>
    <van-dialog v-model="recharge_instructions_show" :title="tipsTitle" confirm-button-text="我知道了" confirm-button-color="#F9591B" @confirm="handleDilogDescript" class="last_dialog">
      <template v-slot:default>
        <div>话费充值正常2小时内到账，最迟24小时；如超时未到请先联系运营商确认，如确认未到，请主动联系平台核实。</div>
      </template>
    </van-dialog>

    <div class="loading" v-if="loading">
      <img src="../../assets/common/loading.gif" />
    </div>
  </div>
</template>

<script>
  import navBar from "./components/navBar";
  import bottomBar from "./components/bottomBar";
  import { getThirdrechargeOilBindList, getThirdrechargeOilDisplayStatus } from './api/index'
  import { Toast } from 'vant';
  export default {
    name: "rechargeOrder",
    data () {
      return {
        isiOSX: false,
        client: 0,
        phone: "",
        moviesList: [],
        musicList: [],
        yunyingshang: "",
        showDialog: false,
        showDialog2: false,
        showDialog3: false,
        dialogMessage: "当前有一笔待支付的订单",
        tipsTitle: "",
        tipsTitle2: "",
        tipsMessages: [],
        activeClass: -1,
        charge_id: "",
        // phone_channel_id: "",
        goods_id: "",
        phoneDenominationList: [],
        phoneActive: { i: -1, j: -1 },
        phonePaying: false,
        charge_pause: 0,
        phone_charge_pause: 0,
        phone_charge_pause_reason: '',
        loading: false,
        musicModuleEnable: true,
        moviesModuleEnable: true,
        rechargeOrderStyle: {
          'max-height': '100%',
          position: '',
          top: '',
          left: '',
          width: '',
        },
        newoilcardicon: require('@/assets/recharge/new-oil-card-icon.png'),
        new_oil_display: 0,
        oil_logo: '', // 油卡图标
        recharge_params: {}, // 充值订单参数
        recharge_instructions_show: false, //充值说明是否显示
      }
    },
    async created () {
      this.package_name = this.$route.query.pkg // 判断当前app包是什么机型的
      this.isiOSX = this.isIphoneX()
      this.deductionUA()
      if (this.$route.query.token) {
        this.$api.setToken(this.$route.query.token.replace('%20', ' '));
      }
      await this.getRechargePhone()
      await this.getModuleList()
      await getThirdrechargeOilDisplayStatus({ charge_id: [14] }).then((res) => {
        this.new_oil_display = res.display
        this.oil_status_info = res
        if (res.display == 1) {
          getThirdrechargeOilBindList({ "oil_type": "all", page: 1, pageSize: 5 }).then((card_res) => {
            this.oil_card_list = card_res.list.data
            this.oil_logo = card_res.logo
          })
        }
      })
    },
    mounted () {
      if (this.isiOSX) {
        this.rechargeOrderStyle = {
          'max-height': 'calc(100% - 20px)',
          position: 'fixed',
          top: '0',
          left: '0',
          width: '100%',
        }
      }
    },
    methods: {
      deductionUA () {
        let ua = navigator.userAgent.toLowerCase();
        if (/iphone|ipad|ipod|macintosh/i.test(ua)) {
          this.client = 11;
        } else if (/android/.test(ua)) {
          this.client = 10;
        }
      },
      checkOrderHasToBePaid () {
        return new Promise((resolve, reject) => {
          this.$api
            .post("/thirdrecharge/member/order/list", { status: 1 })
            .then((res) => {
              resolve(res.data.length)
            })
            .catch((err) => {
              reject(err)
            })
        })
      },
      //左键返回原生
      goBack () {
        this.params("home", "home", "goBack");
      },
      goBack3 () {
        this.showDialog3 = false
        this.params("", "", "goBack");
      },
      // 订单列表
      goOrderList () {
        this.$router.push({
          path: "/recharge/myOrder",
          query: {
            charge_from: 'home',
          },
        });
      },
      cancelEvent () {
        this.phoneActive = { i: -1, j: -1 }
      },
      // 获取充值号码和号码归属地
      async getRechargePhone () {
        await this.$api.get("/member/member/user/detail").then(async (data) => {
          this.phone = data.username;
          sessionStorage.setItem('oilcredits_id', data.credits_id)
          sessionStorage.setItem('oilcoin_id', data.coin_id)
          if (this.phone == '13733333333') {
            this.moviesModuleEnable = false
            this.musicModuleEnable = false
          }
          if (this.phone == '19800000000') {
            this.moviesModuleEnable = false
            this.musicModuleEnable = false
          }
          await this.$api
            .post("/thirdrecharge/member/recharge/member/phone/info", {
              phone: this.phone,
            })
            .then((data) => {
              this.charge_id = data.sp_type
              this.yunyingshang = data.city + data.sp;
            });
        });
      },
      async getModuleList () {
        await this.$api
          .post("/thirdrecharge/member/recharge/charge/list")
          .then((data) => {
            this.moduleLists = data
            this.phoneRechargeDenomination()
            this.charge_pause = data.setting.charge_pause
            this.tipsTitle2 = data.setting.charge_pause_reason
            // 后台关闭充值中心弹框提示并返回
            if (this.charge_pause == 1) {
              this.showDialog3 = true
            }
            // 进入首页不需要弹框待支付订单
            // else if (this.charge_pause == 0) {
            //   this.checkOrderHasToBePaid()
            //   .then(length => {
            //     if (length > 0) {
            //       this.showDialog = true
            //     }
            //   })
            // }
          });

      },
      // 话费充值面额列表
      phoneRechargeDenomination () {
        this.$api
          .post("/thirdrecharge/member/recharge/charge/list")
          .then((data) => {

            this.moviesList = this.arrTrans(4, data.video);
            this.musicList = this.arrTrans(4, data.music);

            // TODO: 这个charge_id现在随便取的一个运营商的，因为后端说3个都一样，如果后面发生改变，处理
            if (data.phone && data.phone.length) {
              // this.charge_id = data.phone[0].charge_id;
              this.phone_charge_pause = data.phone[0].charge_pause
              this.phone_charge_pause_reason = data.phone[0].charge_pause_reason
            } else {
              return
            }
            this.$api
              .post("/thirdrecharge/member/recharge/new/denomination/list", {
                charge_id: this.charge_id,
              })
              .then((data) => {
                if (!data.denominations.data["话费"]) {
                  return
                }
                this.phoneDenominationList = this.arrTrans(
                  3,
                  data.denominations.data["话费"].filter(
                    (item) => item.display == 1
                  )
                );
                // this.phone_channel_id = data.denominations.channel_id;
                this.tipsTitle = data.description.data[0].title;
                const tipsMessage = data.description.data[0].description
                this.tipsMessages = tipsMessage.split("\n").map((item, i) => `${item}`);
                // this.showDialog2 = true
              });
          });
        // this.showDialog = true
      },

      // 油卡及支付跳转原生
      oilCardAdd () {
        this.params("", "", "oilCardAdd");
      },
      oilCardPay () {
        this.params("", "", "oilCardPay");
      },
      // 关闭充值说明弹窗
      handleDilogDescript () {
        this.recharge_instructions_show = false
        if (Object.keys(this.recharge_params).length) {
          let param = JSON.parse(JSON.stringify(this.recharge_params))
          this.params(
            JSON.stringify(param),
            JSON.stringify(param),
            "rechargePay"
          );
          this.recharge_params = {}
        }
      },
      toPay (denomination, i, j) {
        // 模块是否不可用（在维护）
        if (this.phone_charge_pause != 0) {
          this.$toast(this.phone_charge_pause_reason)
          return
        }
        // 防止重复创建订单
        if (this.phonePaying === true) {
          return;
        }
        this.phonePaying = true;
        this.phoneActive = { i: i, j: j };
        this.loading = true
        // 确认订单
        this.$api
          .post("/order/member/order/confirm", {
            order: {
              type: "thirdrecharge",
            },
            charge_id: this.charge_id,
            channel_id: denomination.channel_id,
            goods_id: denomination.id,
            charge_account: this.phone,
            charge_amount: denomination.price,
          })
          .then((data) => {
            let confirm = data.order.confirm;
            // 创建订单
            this.$api
              .post("/order/member/order/create", {
                order: {
                  type: "thirdrecharge",
                  client: this.client,
                  confirm: confirm,
                },
                charge_id: this.charge_id,
                channel_id: denomination.channel_id,
                goods_id: denomination.id,
                charge_account: this.phone,
                charge_amount: denomination.price,

              })
              .then((data) => {
                // console.log(denomination.price);
                this.phoneActive = { i: -1, j: -1 }
                let param = {
                  actual_amount: parseFloat(data.actual_amount).toFixed(2),
                  deduct_coin: data.deduct_coin,
                  deduct_credits: data.deduct_credits,
                  order_amount: parseFloat(data.order_amount).toFixed(2),
                  ordersn: data.ordersn,
                };
                this.phonePaying = false;
                this.loading = false
                this.recharge_denomination = ''
                this.recharge_params = param
                this.recharge_instructions_show = true
              })
              .catch(() => {
                this.recharge_denomination = ''
                this.phonePaying = false;
                this.loading = false
              });
          })
          .catch(err => {
            this.recharge_denomination = ''
            this.phonePaying = false;
            this.loading = false
            // console.log(err);
            if (err.code == 247110) {
              // this.$toast("当月充值话费已上限！");
              this.$toast("话费充值额度不足！");
            }
            if (err.code == 242205) {
              this.$toast("此账号暂不支持话费充值");
            }
            if (err.code == 242206) {
              this.dialogMessage = err.message ? err.message : this.dialogMessage
              this.showDialog = true
              // this.$toast(err.message);
            }
            if (err.code == 242207) {
              this.$toast(err.message ? err.message : this.dialogMessage);
            }
            if (err.code == 247111) {
              this.$toast("该号段暂不支持充值话费");
            }
            if (err.code == 247112 || err.code == 249001) {
              this.$toast(err.message)
            }

            if (err.code == 247110) {
              this.$toast(err.message)
            }
            if (err.code == 121212) {
              this.$toast(err.message)
            }
          })
      },

      // 平台充值
      toPlatformRechage (item) {
        if (item.charge_pause != 0) {
          this.$toast(item.charge_pause_reason)
          return
        }
        this.$router.push({
          path: "/recharge/rechargePlatform",
          query: {
            charge_id: item.charge_id,
            charge_name: item.charge_name,
          },
        })
      },
      goPage (path) {
        if (path == '/new-oli/recharge') {
          if (this.oil_status_info.chargePause == 1) {
            return Toast(this.oil_status_info.chargePauseReason)
          }
          if (this.oil_card_list.length == 0) {
            this.$router.push('/new-oli/cardbind?from=recharge_home')
          } else {
            this.$router.push(path)
          }
        } else {
          this.$router.push(path)
        }

      }
    },
    components: {
      navBar,
      bottomBar,
    },
    filters: {
      phoneFormat (value) {
        return `${value.slice(0, 3)} ${value.slice(3, 7)} ${value.slice(7)}`;
      },
    },
  };
</script>



<style lang='less'>
  .rechargeOrder {
    background-color: #f5f6f7;
    height: 100%;
    overflow-y: scroll;

    .wrapper {
      .top {
        // padding-top: 44px;
        padding-top: 88px;
        height: 211px;
        background: linear-gradient(270deg,
            rgba(244, 26, 60, 1) 0%,
            rgba(252, 116, 12, 1) 100%);
        color: rgba(255, 255, 255, 1);

        .phone {
          margin: 16px 0 0 25px;
          height: 42px;
          line-height: 42px;
          font-size: 30px;
          font-weight: bold !important;
          // border: 0;  // 去除未选中状态边框
          // outline: none; // 去除选中状态边框
          // background-color: rgba(0, 0, 0, 0)
        }

        .desc {
          font-size: 14px;
          font-weight: 400;
          margin: 6px 0 0 25px;
        }
      }

      .phone-recharge {
        max-height: 223px;
        // overflow: scroll;
        margin: 0 12px;
        background: rgba(255, 255, 255, 1);
        border-radius: 10px;
        padding-bottom: 6px;
        transform: translateY(-102px);

        .phone-top {
          display: flex;
          justify-content: space-between;
          align-items: center;
          height: 58px;
          line-height: 58px;

          .title {
            padding-left: 13px;
            font-size: 16px;
            font-weight: bold !important;
            color: rgba(51, 51, 51, 1);
          }

          .tips {
            font-size: 14px;
            padding-right: 11px;
            color: rgba(153, 153, 153, 1);
            display: flex;
            align-items: center;

            img {
              width: 14px;
              height: 14px;
              padding-right: 4px;
            }
          }
        }

        .phone-btn-box {
          max-height: 170px;
          overflow-y: auto;

          .phone-btn {
            padding-right: 10px;
            margin-bottom: 10px;
            display: flex;
            text-align: center;

            .btn {
              position: relative;
              // flex: 1;
              height: 75px;
              // width: 33.3%;
              // margin-left: 10px;
              width: 30.12%;
              margin-left: 3.18%;
              box-sizing: border-box;
              border-radius: 6px;
              border: 1px solid #ffffff;

              .price {
                height: 28px;
                line-height: 28px;
                margin: 12px 0 6px;
                font-size: 20px;
                font-weight: bold !important;
                color: rgba(51, 51, 51, 1);
              }

              .credit {
                font-size: 12px;
                color: rgba(153, 153, 153, 1);

                span {
                  color: #f9591b;
                }
              }

              &.phone-active {
                background-color: #f9591b;

                .price {
                  color: #ffffff;
                }

                .credit {
                  color: #ffffff;

                  span {
                    color: #ffffff;
                  }
                }
              }

              &::before {
                content: "";
                position: absolute;
                left: 0;
                width: 200%;
                height: 200%;
                border: 1px solid #f9591b;
                border-radius: 12px;
                /* 也可以设置圆角 */
                -webkit-transform-origin: 0 0;
                -moz-transform-origin: 0 0;
                -ms-transform-origin: 0 0;
                -o-transform-origin: 0 0;
                transform-origin: 0 0;
                -webkit-transform: scale(0.5, 0.5);
                -ms-transform: scale(0.5, 0.5);
                -o-transform: scale(0.5, 0.5);
                transform: scale(0.5, 0.5);
                -webkit-box-sizing: border-box;
                -moz-box-sizing: border-box;
                box-sizing: border-box;
              }
            }
          }
        }
      }

      .new-oli-enter-div {
        transform: translateY(-102px);
        margin: 12px;
        padding: 10px 16px;
        background-color: #fff;
        border-radius: 10px;

        .new-oli-title {
          font-size: 16px;
          font-weight: 600;
          text-align: left;
          color: #333333;
          line-height: 22px;
          margin-bottom: 17px;
        }

        .new-oli-second-div {
          padding: 0 0 18px;
          display: flex;
          justify-content: space-between;

          .oli-second-left {
            width: 70px;
            height: 70px;
            border-radius: 50%;
            text-align: center;
            overflow: hidden;

            img {
              width: 70px;
              height: 70px;
              // margin-top: 14px;
            }
          }

          .oli-second-center {
            font-size: 15px;
            font-weight: 600;
            text-align: left;
            color: #343333;
            line-height: 21px;
            margin: 14px 14px 14px 15px;

            span {
              display: inline-block;
              color: #FF002E;
            }

            div {
              white-space: nowrap;

              &:first-child {
                margin-bottom: 4px;
              }

              &:last-child {
                font-size: 12px;
                font-weight: 400;
                text-align: left;
                color: #aaaaaa;
                line-height: 17px;
              }
            }
          }

          .oli-second-right {
            height: 30px;
            width: 70px;
            background: linear-gradient(135deg, #fb700d, #f31f38);
            border-radius: 15px;
            text-align: center;
            line-height: 30px;
            margin-top: 20px;

            span {
              font-size: 14px;
              font-weight: 500;
              text-align: left;
              color: #ffffff;
              line-height: 20px;
            }
          }
        }
      }

      .buttom-wrapper {
        margin: 12px 12px 0;
        transform: translateY(-102px);

        .oil-card {
          background-color: #fff;
          border-radius: 10px;

          .title {
            font-size: 16px;
            font-weight: bold !important;
            color: #333333;
            padding: 12px 0 13px 12px;
          }

          .isCard {
            height: 100%;
            display: flex;
            margin: 0 12px 0 4px;

            div {
              flex: 1;
              margin-left: 7px;
              padding: 0 12px 16px;
              height: 84px;
              display: flex;
              justify-content: space-between;
              align-items: center;

              span {
                font-size: 20px;
                font-weight: bold !important;
                color: #333333;
              }

              a {
                text-align: center;
                width: 70px;
                height: 30px;
                background: rgba(255, 255, 255, 1);
                border-radius: 15px;
                display: inline-block;
                font-size: 14px;
                color: #627cf4;
                line-height: 30px;
              }
            }

            .left {
              background: url("../../assets/recharge/card@2x.png") no-repeat;
              background-size: contain;
            }

            .right {
              background: url("../../assets/recharge/nocard@2x.png") no-repeat;
              background-size: contain;
            }
          }
        }

        .movies-musics {
          background-color: #fff;
          border-radius: 10px;
          margin-top: 12px;

          .title {
            font-size: 16px;
            font-weight: bold !important;
            color: #333333;
            padding: 12px 0 13px 12px;
          }

          .moviesList {
            ul {
              display: flex;

              li {
                width: 25%;
                margin: 12px 0;
                text-align: center;

                img {
                  width: 40px;
                  height: 40px;
                  margin-bottom: 6px;
                }

                div {
                  font-size: 14px;
                  color: #333333;
                }
              }
            }
          }
        }
      }
    }

    .van-dialog {
      width: 274px;
      border-radius: 3px;

      .van-dialog__content {
        .van-dialog__message {
          font-size: 16px;
          padding: 30px 49px;
        }
      }
    }

    .last_dialog,
    .llast_dialog {
      color: #333333;
      line-height: 26px;

      .van-dialog__header {
        font-size: 18px;
        font-weight: bold !important;
        padding: 20px 0;
      }

      .van-dialog__content {
        padding: 0 12px 44px 14px;
        font-size: 16px;
      }
    }

    .loading {
      text-align: center;
      position: fixed;
      top: 0;
      left: 0;
      z-index: 9999;
      width: 100%;
      height: 100%;
      background: rgba(0, 0, 0, 0.7);

      img {
        width: 35%;
        margin-top: 65%;
      }
    }

    // .last_dialog {
    //   .van-dialog__header {
    //     padding: 15px 0 10px;
    //   }
    //   .van-dialog__content {
    //     max-height: 90px;
    //     overflow: scroll;
    //   }
    // }
    .bottom-bar {
      position: fixed;
      bottom: 0;
      left: 0;
      width: 100%;
      height: 20px;
      background-color: #f5f6f7;
    }
  }
</style>